export const FILE_TYPES = {
    csv: 'text/csv;charset=utf-8',
    pdf: 'application/pdf',
    svg: 'image/svg+xml',
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    image: 'image/*',
};
export const FILE_SIZE_UNITS = {
    byte: 'B',
    kilobyte: 'kB',
    megaByte: 'MB',
    gigaByte: 'GB',
};
export const UPLOAD_FILE_TYPES = {
    csv: {
        label: 'CSV',
        type: 'text/csv;charset=utf-8',
    },
    pdf: {
        label: 'PSD',
        type: 'image/*,.pdf',
    },
    svg: {
        label: 'SVG',
        type: 'image/svg+xml',
    },
    jpg: {
        label: 'JPG',
        type: 'image/jpg',
    },
    jpeg: {
        label: 'JPEG',
        type: 'image/jpeg',
    },
    png: {
        label: 'PNG',
        type: 'image/png',
    },
};
